import {
  TRAILER_DETAILS_STEP,
  TRAILER_INTRO_STEP,
  TRAILER_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Trailer/trailerSteps";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export const mapTrailerToForm = (
  existingState: Record<string, any>,
  localStorageData?: Record<string, any>,
): FormStates => {
  if (!localStorageData) {
    return {};
  }
  const formStates: FormStates = {};
  Object.entries(localStorageData).forEach(([key, value]) => {
    switch (key) {
      case TRAILER_INTRO_STEP.id:
        formStates[TRAILER_INTRO_STEP.id] = {
          brand: value.brand,
          registrationYear: value.registrationYear,
          model: value.model,
        };
        return;
      case TRAILER_DETAILS_STEP.id:
        formStates[TRAILER_DETAILS_STEP.id] = {
          coverageAmount: value.coverageAmount,
          injuries: value.injuries,
          injuryYear: value.injuryYear,
        };
        return;
      case TRAILER_PRICE_STEP.id:
        const { coverage } = value;
        if (coverage) {
          formStates[TRAILER_PRICE_STEP.id] = {
            coverage,
          };
        }
        return;
      default:
        return;
    }
  });
  return formStates;
};
